<!-- container-xxl -->
<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
				<!-- <div class="card-body"> -->
					<!-- <div class="stepper-wrapper">
						<div class="stepper-item" [ngClass]="{ 'completed': stage.status }"
							*ngFor="let stage of stageData">
							<div class="step-counter">{{stage.id}}</div>
							<div class="step-name">{{stage.paraDescription}}</div>
						</div>
					</div> -->
					<div class="row">
						<div class="col-lg-8">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Project Details</h5>
								</legend>
								
								<div class="row">
									<div class="col-lg-6">
										<div class="form-group row">
											<div class="col-md-4 col-form-label">
												<label><b>Application No.:</b></label>
											</div>
											<div class="col-md-8 col-form-label">
												<p class="text-justify">{{form1_data?.applicationNumber}}</p><br />
											</div>
										</div>
									</div>
									<!-- <div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Applicant Category:</b></label>
											</div>
											<div class="col-8 col-form-label">
											
										<p class="text-justify" *ngIf="form1_data?.applicantCategory == '1'" > Academic Institutions</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '2'" > R&D Institutions</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '3'" > Government Institutions</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '4'" > PSUs</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '5'" > Private Research Institutions</p>
							           <p class="text-justify" *ngIf="form1_data?.applicantCategory == '6'" > Industries in partnership with above mentioned entities</p>
							           <p class="text-justify" *ngIf="form1_data?.applicantCategory == '7'" > Consortium/ JV (mention lead partner with composition)</p>
											</div>
										</div>
									</div> -->
                                    <div class="col-lg-6">
                                        <div class="form-group row">
                                            <div class="col-md-4 col-form-label">
                                                <label><b>Created Date:</b></label>
                                            </div>
                                            <div class="col-md-8 col-form-label">
                                                <p class="text-justify">{{form1_data?.createdAt}}</p>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-md-4 col-form-label">
                                                <label><b>Modified Date:</b></label>
                                            </div>
                                            <div class="col-md-8 col-form-label">
                                                <p class="text-justify">{{form1_data?.modifiedAt}}</p>
                                            </div>
                                        </div>
										
                                    </div>
                                   
								</div>
								<div class="row">
									<div class="col-lg-12">
										<div class="form-group row">
											<div class="col-md-2 col-form-label">
												<label><b>Project Title:</b></label>
											</div>
											<div class="col-md-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.projectTitle}}</p>
											</div>
										</div>
									</div>
									
								</div>

                                <div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-md-2 col-form-label">
												<label><b>Summary:</b></label>
											</div>
											<div class="col-md-10 col-form-label text-justify">
												<p class="text-justify"> {{form1_data?.summary}}</p>
											</div>
										</div>
									</div>
								</div>
								
							
									
							</fieldset>
						</div>
						
					
						<div class="form-group col-lg-4 pt-1">
							<!-- <h4>Proposal Format - 2</h4> -->
							<fieldset>
								
								<div class="table-responsive table-bordered">
									
									<table class="table" style="margin-bottom: 0!important;">
										<tbody>
											
											
											
											<tr>
												<td scope="col" class="text-wrap" colspan="2"><b>Format</b>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">Proposal Format</td>
												
												<td *ngIf="(form1_data?.annexureFirstFile != '')">
													<a href="{{form1_data?.annexureFirstFile}}"
														target="_blank"><i style="font-size: 25px !important;"
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<!-- <tr>
												<td scope="col" class="text-wrap text-justify">
													ANNEXURE-II(A)
												</td>
												<td class="text-justify">
													<span></span>
												</td>
												<td *ngIf="(form1_data?.annexureSecondFile != '')">
													<a href="{{form1_data?.annexureSecondFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>

												</td>
											</tr> -->
											<!-- <tr>
												<td scope="col" class="text-wrap text-justify">
													ANNEXURE-II(B)
												</td>
												<td class="text-justify">
													<span></span>
												</td>
												<td *ngIf="(form1_data?.annexureThirdFile != '')">
													<a href="{{form1_data?.annexureThirdFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr> -->
											<!-- <tr>
												<td scope="col" class="text-wrap text-justify">
													<span>ANNEXURE-II (C)</span>
												</td>
												<td>
												</td>
												<td *ngIf="(form1_data?.annexureFourthFile != '')">
													<a href="{{form1_data?.annexureFourthFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr> -->
											
											

										
										</tbody>
									</table>
								</div>
							</fieldset>
						</div>
					</div>
				<!-- </div> -->
			<!-- </div> -->
		</section>
	</div>
	
</div>